exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__content___1aMIq {\n  width: 100%;\n  height: 100%;\n  padding-left: 0;\n  padding-right: 0; }\n\n.style__modal___sKgpR .style__cancel___37yqf {\n  position: absolute;\n  left: 90px;\n  bottom: 24px;\n  height: 34px;\n  padding-right: 12px;\n  padding-left: 12px;\n  min-width: 70px; }\n\n.style__modal___sKgpR .btn-info {\n  background-color: #46cba0;\n  border-color: #46cba0; }\n  .style__modal___sKgpR .btn-info:hover {\n    background-color: #40bd94;\n    border-color: #40bd94; }\n", ""]);

// exports
exports.locals = {
	"content": "style__content___1aMIq",
	"modal": "style__modal___sKgpR",
	"cancel": "style__cancel___37yqf"
};